import * as React from 'react';
import { InPageDialog } from 'damco-components';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import CostRevTable from './CostRevTable';
interface IParams {
    funcName: string;
    finOpsStatus: string[];
    revenue: any[],
    readOnly: boolean,
    cost: any[],
    splitCols: any[],
    isFetchLoading: boolean;
    forceFooterUpdate: boolean;
    showInvoices: boolean;
    setSelectedInvoices?: (props: any) => void;
	vatPartnersEdit?: () => void;
    billToPartyEdit?: () => void;
    fetchData: (s: any, t: any, dataType?: string) => void;
    addAction: (data: any, target: string) => void;
    editAction: (data: any, target: string) => void;
    deleteAction: (data: any, reason: string, target: string) => void;
    isExtraDocumentFeatureEnabled: boolean;
    isReceivingFCR: boolean;
    isJobClosed?: boolean;
    salesOrderResponse:any;
    isSourceAthena?: boolean;
    vendorsData?: any;
    isNftpBillable?: boolean;
    isNftpRoeEnabled?: boolean;
}
export const CostAndRevenueTablesWrap: React.FunctionComponent<IParams> = (props) => {
    const getTable = (propData: any[], name: string, type: string) => {
        return <CostRevTable
            id={`${props.funcName}-charges-${name}`}
            isDestination={props.funcName === 'ets' ? true : false}
            readOnly={props.readOnly}
            data={propData}
            showInvoices={props.showInvoices}
			showVatPartnersEdit={props.showInvoices}
            forceFooterUpdate={props.forceFooterUpdate}
            subCols={props.splitCols}
            finOpsStatus={props.finOpsStatus}
            tableTitle={`${name} Table`}
            type={type}
            isLoading={props.isFetchLoading}
            isEditable={false}
            isExpandable={true}
            labelAddAction={`Add ${name}`}
            addAction={(e: any) => props.addAction(e, type)}
            editAction={(e: any) => props.editAction(e, type)}
            deleteAction={(e: any, reason: string) => props.deleteAction(e, reason, type)}
            fetchData={props.fetchData}
            setSelectedInvoices={props.setSelectedInvoices}
			vatPartnersEdit={props.vatPartnersEdit}
            billToPartyEdit={props.billToPartyEdit}
            funcName={props.funcName}
            isReceivingFCR={props.isReceivingFCR}
            isJobClosed={props.isJobClosed}
            salesOrderResponse={props.salesOrderResponse}
            isSourceAthena={props.isSourceAthena}
            vendorsData={props.vendorsData}
            isNftpBillable={props.isNftpBillable}
            isNftpRoeEnabled={props.isNftpRoeEnabled}
        />
    }
    return (
        <div className={`${props.readOnly ? 'non-checks' : 'checks'}`}>
            {props.readOnly && <div className="padding-bottom-large"><InPageDialog
                showDialog={props.readOnly}
                type={'info'}
                message={'Updates only available through Export Job view'}
                closeMethod={() => false}
            /></div>}
            {props.revenue && getTable(props.revenue, 'Revenue', CostColumnsData.TYPES.REVENUE)}
            {props.cost && getTable(props.cost, 'Cost', CostColumnsData.TYPES.COST)}
        </div>
    );
}